import { useCallback } from 'react';
import { useEventDirectory } from '../directory/useEventDirectory';

export function useSponsors(eventId, options = {}) {
    const { filter = identity, sortBy: sortCriteria } = options,
        sponsorsFilter = useCallback((item) => item.is_sponsor && filter(item), [filter]);

    return useEventDirectory(eventId, {
        filter: sponsorsFilter,
        sortBy: sortCriteria,
    });
}
